'use client';

var CHANGE_JOB_TITLE = 'api-gateway/v1.0/profile/job-title';
var CHANGE_PHONE_NUMBER = 'api-gateway/v1.0/profile/change-phone';
var ATTACHED_RESUME_VALIDATE = 'attached-resumes-validation/v1/validate-resume';
var ENDPOINT_UPDATE_RESUME_FILE = 'profile/update-resume-file';
var PROFILE_LEVEL = 'api-gateway/v1.0/profile/level';
var RESUME_SETTING_INFO = 'api-gateway/v2.0/profile/resume-setting-info';
var JOBLEVEL = 'meta/v1.0/job-levels';
var BASIC_INFO = 'api-gateway/v1.0/profile/basic-info';
var SEARCHABLE = 'api-gateway/v1.0/profile/resume-change-searchable';
var PROFILE_COOKIE = 'api-gateway/v1.0/profile/cookie';
var SKILL_TAGS = 'skill-tags/api/v1/skills/suggestion';
var REFRESH_PROFILE = 'api-gateway/v1.0/profile/refresh-profile';
var USER_SKILL = 'api-gateway/v1.0/profile/skill';
var BASIC_INFO_V2 = 'api-gateway/v2.0/profile/info';
var DEFAULT_ALLOW_FILES_EXT = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];
var DEFAULT_ALLOW_EXT = '.doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf';
var DEFAULT_LIMIT_FILE_SIZE = 5120000; // 5MB
var DEFAULT_SUCCESS_CODE = 200;

export { ATTACHED_RESUME_VALIDATE, BASIC_INFO, BASIC_INFO_V2, CHANGE_JOB_TITLE, CHANGE_PHONE_NUMBER, DEFAULT_ALLOW_EXT, DEFAULT_ALLOW_FILES_EXT, DEFAULT_LIMIT_FILE_SIZE, DEFAULT_SUCCESS_CODE, ENDPOINT_UPDATE_RESUME_FILE, JOBLEVEL, PROFILE_COOKIE, PROFILE_LEVEL, REFRESH_PROFILE, RESUME_SETTING_INFO, SEARCHABLE, SKILL_TAGS, USER_SKILL };
//# sourceMappingURL=const.js.map
